/**
 * Problem solution HTML renderer.
 */
import React from "react";

import SafeHtml from "pages/common/SafeHtml";

/**
 * Renders the `<solution>` OLX child when hints are shown.
 *
 * @param {{ tag: Element }} props
 */
export default function SolutionRender(props) {
  const { tag, isShowHint } = props;

  if(isShowHint) {
    return <SafeHtml className="mt-4 text-muted" html={tag.innerHTML} course />;
  } else {
    return <></>
  }
}
